import React from "react";
import TableWrapper from "../Table/tableWrapper";
import {useSelector} from "react-redux";
import { createTableHeadersAndData } from "../../Util/TableHelpers/commonHelper";
import { DATE_FORMATS, formatDate } from "../../Util/dateHelpers";
import { partnerPayoutsSelector } from "../../Reducers/payoutsReducer";
import { PAYOUT_TYPES } from "../../Model/payoutObjects";

const NoPayoutsText = "You do not have any payouts";

const columnConfigs = [
    {
        id: "transferId",
        name: "TransferID",
        dataFunc: (payout) => payout.getTransferId(),
    },
    {
        id: "recipientEmail",
        name: "Recipient Email",
        dataFunc: (payout) => payout.getType() === PAYOUT_TYPES.MANUAL_PAYPAL ? payout.getRecipientEmail() : "--",
    },
    {
        id: "initiatedAt",
        name: "Initiated At",
        dataFunc: (payout) => formatDate(payout.getInitiatedAt(), DATE_FORMATS.DD_MMMc_YYYY),
    },
    {
        id: "amount",
        name: "Amount($)",
        dataFunc: (payout) => payout.getAmountInUsd().toFixed(2),
    },
    {
        id: "description",
        name: "Description",
        dataFunc: (payout) => payout.getDescription(),
    },
    {
        id: "status",
        name: "Status",
        dataFunc: (payout) => payout.isComplete() ? 'Completed' : 'Processing'
    }
];

const PayoutsTableSection = () => {
    const option = {
        minWidth: false
    }
    const payoutsObj = useSelector(partnerPayoutsSelector);
    if (payoutsObj === null) return <></>

    const payouts = payoutsObj.getPayoutsSortedByDateDecreasing();
    const processedColumnConfigs = columnConfigs.filter(c => {
        if (c.id === "recipientEmail" && !payoutsObj.hasManualPaypal()) {
            return false;
        }
        return true;
    })
    const {headers, data} = createTableHeadersAndData(payouts, processedColumnConfigs);

    return (
        <div className="p-2 mt-2 ps-0">
            <span className="sub-title">Payouts</span>
            <TableWrapper 
                tableHeaderArr={headers} 
                tableBodyArr={data} 
                errorText={NoPayoutsText}
                option={option}
            />
        </div>
    )
}

export default PayoutsTableSection;
